import { HttpService } from '@/services/HttpService';
class Cache {
  subdomain = '/cache';

  /**
   * Checks if the cache should be cleared
   * @returns {Promise}
   */
  getCacheClear() {
    return HttpService.get(`${this.subdomain}/clear`);
  }

  /**
   * Informs the backend that the cache has been cleared
   * @returns {Promise}
   */
  putCacheClear() {
    return HttpService.put(`${this.subdomain}/clear`);
  }
}

export default new Cache();
